// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { lightbulb16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-lightbulb': IconLightbulb;
    }
}

/**
 * The icon component for the 'lightbulb' icon
 */
export class IconLightbulb extends Icon {
    public constructor() {
        super(lightbulb16X16);
    }
}

registerIcon('icon-lightbulb', IconLightbulb);
export const iconLightbulbTag = 'nimble-icon-lightbulb';
